import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import ReactExport from 'react-export-excel-fixed-xlsx';

import {
	setModoTela, initForm, salvar, excluir, processarApuracao, getListaMetaApuracao, importarCustos, imprimir
} from './metaBaseOperadorTrimestreActions';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import Select from '../common/form/select';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';

class MetaBaseOperadorTrimestreApuracao extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: '',
		ano: new Date().getFullYear(),
		trimestre: new Date().getMonth() <= 2 ? 1 : (new Date().getMonth() <= 5 ? 2 : (new Date().getMonth() <= 8 ? 3 : 4))
	}

	componentDidMount() {

		const fileSelector = document.createElement('input');
		fileSelector.setAttribute('type', 'file');
		fileSelector.addEventListener("change", async (data) => {

			let reader = new FileReader();
			let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
			if (!file) {
				file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
			}

			if (file) {

				if (!file.type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
					|| (file.type.includes('application/excel') || file.type.includes('application/vnd.ms-excel'))) {
					setError('Selecione apenas (.XLSX)');
					return;
				}

				let tabela = [];
				await readXlsxFile(file, { sheet: 1 }).then((rows) => {
					tabela = rows;
				});

				this.props.importarCustos(tabela);

				reader.readAsDataURL(file);

			}
		});

		this.fileSelector = fileSelector;

	}

    componentWillMount() {
        this.props.getListaMetaApuracao();
    }


    render() {
        return (
            <div>
                <Content>
					{this.lista()}
                </Content>
            </div>
        )
    }

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		const perfilBase = this.props.usuarioCarregado && this.props.usuarioCarregado.id_perfil == 17;
		const perfilAdministrador = this.props.usuarioCarregado && this.props.usuarioCarregado.id_perfil == 2;
		
		return (
			<ContentCard>

				{this.modalReprocessar()}

				<ContentCardBody>
					<Row>

						<Select
							options={[{ id: 2025, valor: 2025 }, { id: 2026, valor: 2026 }]}
							label='Ano'
							cols='12 4 3 2'
							placeholder='Selecione o ano'
							value={this.state.ano}
							onChange={value => {
								this.setState({
									...this.state,
									ano: value
								});
							}} />
								
						<Select
							options={[{ id: 1, valor: '1º trimestre' }, { id: 2, valor: '2º trimestre' }, { id: 3, valor: '3º trimestre' }, { id: 4, valor: '4º trimestre' } ]}
							label='Trimestre'
							cols='12 4 3 2'
							placeholder='Selecione o trimestre'
							value={this.state.trimestre}
							onChange={value => {
								this.setState({
									...this.state,
									trimestre: value
								});
							}} />
					</Row>
					 
					{this.props.lista.filter(item => {
						if (this.state.ano && this.state.trimestre) {
							return item.ano == this.state.ano && item.trimestre == this.state.trimestre;
						}
						return false;
					}).filter(item => {
						if (!perfilAdministrador && !perfilBase) {
							return false;
						} else if (perfilBase && item.id_usuario != this.props.usuarioCarregado.id) {
							return false;
						} else {
							return true;
						}
					}).map(item => {
						
						return (
							<Table responsive key={item.id} border>
								<THead>
									<Tr backgroundColor={'#dfe2f5'}>
										<Th fontSize={18}>
											{item.nome_usuario} ({item.id_usuario})
											{perfilAdministrador &&
											<button 
												type='button'
												class='btn btn-success btn-flat'
												style={{ marginLeft: 16 }}
												onClick={() => {
													this.setModalReprocessar({ ...item });
												}}>
												<i class='fas fa-sync' style={{ fontSize: 18 }}></i>
											</button>}
											{perfilAdministrador &&
											<button 
												type='button'
												class='btn btn-primary btn-flat'
												style={{ marginLeft: 16 }}
												onClick={() => {
													this.props.imprimir({ 
														...item,
														ano_trimestre: `${item.trimestre}° trimestre de ${item.ano}`,

														//Indicador I — Eficiência Operacional (Tempo de Carga/Descarga)
														operacional_percentual_faixa4: `${FormatUtils.formatarValorTelaDecimal(item.operacional_percentual_faixa4, 2)}%`,
														operacional_percentual_realizado_mes1: `${FormatUtils.formatarValorTelaDecimal(item.operacional_percentual_realizado_mes1, 2)}%`,
														operacional_percentual_realizado_mes2: `${FormatUtils.formatarValorTelaDecimal(item.operacional_percentual_realizado_mes2, 2)}%`,
														operacional_percentual_realizado_mes3: `${FormatUtils.formatarValorTelaDecimal(item.operacional_percentual_realizado_mes3, 2)}%`,

														//Indicador II — Processos Recorrentes - Infinitum
														proceso_percentual_meta: `${FormatUtils.formatarValorTelaDecimal(item.proceso_percentual_meta, 2)}%`,
														processo_percentual_realizado_mes1: `${FormatUtils.formatarValorTelaDecimal(item.processo_percentual_realizado_mes1, 2)}%`,
														processo_percentual_realizado_mes2: `${FormatUtils.formatarValorTelaDecimal(item.processo_percentual_realizado_mes2, 2)}%`,
														processo_percentual_realizado_mes3: `${FormatUtils.formatarValorTelaDecimal(item.processo_percentual_realizado_mes3, 2)}%`,
														
														//Indicador III — Cumprimento de Leis e Normas Internas
														qualidade_faixa: '100,00%',
														qualidade_realizado_mes1: `${FormatUtils.formatarValorTelaDecimal(item.qualidade_realizado_mes1, 2)}%`,
														qualidade_realizado_mes2: `${FormatUtils.formatarValorTelaDecimal(item.qualidade_realizado_mes2, 2)}%`,
														qualidade_realizado_mes3: `${FormatUtils.formatarValorTelaDecimal(item.qualidade_realizado_mes3, 2)}%`,
														
														//Realizado
														percentual_meta_geral: `${FormatUtils.formatarValorTelaDecimal(item.percentual_meta_geral, 2)}%`,
														percentual_realizado_mes1: `${FormatUtils.formatarValorTelaDecimal(item.percentual_realizado_mes1, 2)}%`,
														percentual_realizado_mes2: `${FormatUtils.formatarValorTelaDecimal(item.percentual_realizado_mes2, 2)}%`,
														percentual_realizado_mes3: `${FormatUtils.formatarValorTelaDecimal(item.percentual_realizado_mes3, 2)}%`,
														
														//Faixa
														pagamento_faixa_realizado_nome_mes1: item.pagamento_faixa_realizado_nome_mes1,
														pagamento_faixa_realizado_nome_mes2: item.pagamento_faixa_realizado_nome_mes2,
														pagamento_faixa_realizado_nome_mes3: item.pagamento_faixa_realizado_nome_mes3,
														
														//Valor
														pagamento_valor_faixa3: `R$ ${FormatUtils.formatarValorTelaDecimal(item.pagamento_valor_faixa3, 2)}`,
														pagamento_faixa_realizado_valor_mes1: `R$ ${FormatUtils.formatarValorTelaDecimal(item.pagamento_faixa_realizado_valor_mes1, 2)}`,
														pagamento_faixa_realizado_valor_mes2: `R$ ${FormatUtils.formatarValorTelaDecimal(item.pagamento_faixa_realizado_valor_mes2, 2)}`,
														pagamento_faixa_realizado_valor_mes3: `R$ ${FormatUtils.formatarValorTelaDecimal(item.pagamento_faixa_realizado_valor_mes3, 2)}`,
										
														//Total
														pagamento_valor_faixa3: `R$ ${FormatUtils.formatarValorTelaDecimal(item.pagamento_valor_faixa3 * 3, 2)}`,
														pagamento_valor_realizado: `R$ ${
															FormatUtils.formatarValorTelaDecimal(
																parseFloat(item.pagamento_faixa_realizado_valor_mes1 || 0)
																+ parseFloat(item.pagamento_faixa_realizado_valor_mes2 || 0)
																+ parseFloat(item.pagamento_faixa_realizado_valor_mes3 || 0), 2)
														}`
													});
												}}>
												<i class='fas fa-file-pdf' style={{ fontSize: 18 }}></i>
											</button>}
											{/*
											<button 
												type='button'
												class='btn btn-default btn-flat'
												style={{ marginLeft: 16 }}
												onClick={() => {
													this.props.imprimir({
														...item,
														nome: item.nome_usuario,
														ano_trimestre: `${item.trimestre}° trimestre de ${item.ano}`
													});															
												}}>
												<i class='fas fa-file-pdf' style={{ fontSize: 18 }}></i>
											</button>*/}
										</Th>
										<Th alignCenter fontSize={18}>Meta</Th>
										<Th alignCenter fontSize={18}>Mês 1</Th>
										<Th alignCenter fontSize={18}>Mês 2</Th>
										<Th alignCenter fontSize={18}>Mês 3</Th>
									</Tr>
								</THead>
								<TBody>
									<Tr>
										<Td width={500}>Indicador I — Eficiência Operacional (Tempo de Carga/Descarga)</Td>
										<Td width={100} alignCenter fontSize={18}>{FormatUtils.formatarValorTelaDecimal(item.operacional_percentual_faixa4, 2)}%</Td>
										<Td width={100} alignCenter fontSize={18}
											title={
												`Incidente: ${item.operacional_incidente_mes1 ? 'SIM' : 'NÃO'}`
												+ `\nEficiência: ${FormatUtils.formatarValorTela(item.operacional_percentual_realizado_mes1, 2)}`
											}>{FormatUtils.formatarValorTelaDecimal(item.operacional_percentual_realizado_mes1, 2)}%</Td>
										<Td width={100} alignCenter fontSize={18}
											title={
												`Incidente: ${item.operacional_incidente_mes2 ? 'SIM' : 'NÃO'}`
												+ `\nEficiência: ${FormatUtils.formatarValorTela(item.operacional_percentual_realizado_mes2, 2)}`
											}>{FormatUtils.formatarValorTelaDecimal(item.operacional_percentual_realizado_mes2, 2)}%</Td>
										<Td width={100} alignCenter fontSize={18}
											title={
												`Incidente: ${item.operacional_incidente_mes3 ? 'SIM' : 'NÃO'}`
												+ `\nEficiência: ${FormatUtils.formatarValorTela(item.operacional_percentual_realizado_mes3, 2)}`
											}>{FormatUtils.formatarValorTelaDecimal(item.operacional_percentual_realizado_mes3, 2)}%</Td>
									</Tr>
									<Tr>
										<Td width={500}>Indicador II — Processos Recorrentes - Infinitum</Td>
										<Td width={100} alignCenter fontSize={18}>{FormatUtils.formatarValorTelaDecimal(item.proceso_percentual_meta, 2)}%</Td>
										<Td width={100} alignCenter fontSize={18}
											title={
												(JSON.parse(item.processo_rotinas_mes1) || []).map(rotina => 
													`${rotina.nome_tipo}`
													+ `\nEsperados: ${FormatUtils.formatarValorTelaDecimal(rotina.esperados, 0)}`
													+ `\nRealizados: ${FormatUtils.formatarValorTelaDecimal(rotina.realizados, 0)}`
													+ `\nPercentual: ${FormatUtils.formatarValorTelaDecimal(rotina.percentual, 0)}%`
												).join('\n\n')
											}>{FormatUtils.formatarValorTelaDecimal(item.processo_percentual_realizado_mes1, 2)}%</Td>
										<Td width={100} alignCenter fontSize={18}
											title={
												(JSON.parse(item.processo_rotinas_mes2) || []).map(rotina => 
													`${rotina.nome_tipo}`
													+ `\nEsperados: ${FormatUtils.formatarValorTelaDecimal(rotina.esperados, 0)}`
													+ `\nRealizados: ${FormatUtils.formatarValorTelaDecimal(rotina.realizados, 0)}`
													+ `\nPercentual: ${FormatUtils.formatarValorTelaDecimal(rotina.percentual, 0)}%`
												).join('\n\n')
											}>{FormatUtils.formatarValorTelaDecimal(item.processo_percentual_realizado_mes2, 2)}%</Td>
										<Td width={100} alignCenter fontSize={18}
											title={
												(JSON.parse(item.processo_rotinas_mes3) || []).map(rotina => 
													`${rotina.nome_tipo}`
													+ `\nEsperados: ${FormatUtils.formatarValorTelaDecimal(rotina.esperados, 0)}`
													+ `\nRealizados: ${FormatUtils.formatarValorTelaDecimal(rotina.realizados, 0)}`
													+ `\nPercentual: ${FormatUtils.formatarValorTelaDecimal(rotina.percentual, 0)}%`
												).join('\n\n')
											}>{FormatUtils.formatarValorTelaDecimal(item.processo_percentual_realizado_mes3, 2)}%</Td>
									</Tr>

									<Tr>
										<Td width={500}>Indicador III — Cumprimento de Leis e Normas Internas</Td>
										<Td width={100} alignCenter fontSize={18}>{FormatUtils.formatarValorTelaDecimal(100, 2)}%</Td>
										<Td width={100} alignCenter fontSize={18}
											title={
												`Não registrou checklist de gabine: ${item.qualidade_perdeu_checklist_gabine_mes1 ? 'SIM' : 'NÃO'}`
												+ `\n\nAutuação por inobservância de norma ou lei: ${item.qualidade_perdeu_lei_norma_mes1 ? 'SIM' : 'NÃO'}`
												+ `\n\nDano caudado por conduta imprudente: ${item.qualidade_perdeu_imprudencia_mes1 ? 'SIM' : 'NÃO'}`
											}>{FormatUtils.formatarValorTelaDecimal(item.qualidade_realizado_mes1, 2)}%</Td>
										<Td width={100} alignCenter fontSize={18}
											title={
												`Não registrou checklist de gabine: ${item.qualidade_perdeu_checklist_gabine_mes2 ? 'SIM' : 'NÃO'}`
												+ `\n\nAutuação por inobservância de norma ou lei: ${item.qualidade_perdeu_lei_norma_mes2 ? 'SIM' : 'NÃO'}`
												+ `\n\nDano caudado por conduta imprudente: ${item.qualidade_perdeu_imprudencia_mes2 ? 'SIM' : 'NÃO'}`
											}>{FormatUtils.formatarValorTelaDecimal(item.qualidade_realizado_mes2, 2)}%</Td>
										<Td width={100} alignCenter fontSize={18}
											title={
												`Não registrou checklist de gabine: ${item.qualidade_perdeu_checklist_gabine_mes3 ? 'SIM' : 'NÃO'}`
												+ `\n\nAutuação por inobservância de norma ou lei: ${item.qualidade_perdeu_lei_norma_mes3 ? 'SIM' : 'NÃO'}`
												+ `\n\nDano caudado por conduta imprudente: ${item.qualidade_perdeu_imprudencia_mes3 ? 'SIM' : 'NÃO'}`
											}>{FormatUtils.formatarValorTelaDecimal(item.qualidade_realizado_mes3, 2)}%</Td>
									</Tr>

									<Tr>
										<Td width={500} bold fontSize={18}>Realizado</Td>
										<Td width={100} bold alignCenter fontSize={18}>{FormatUtils.formatarValorTelaDecimal(item.percentual_meta_geral, 2)}%</Td>
										<Td width={100} bold alignCenter fontSize={18}>{FormatUtils.formatarValorTelaDecimal(item.percentual_realizado_mes1, 2)}%</Td>
										<Td width={100} bold alignCenter fontSize={18}>{FormatUtils.formatarValorTelaDecimal(item.percentual_realizado_mes2, 2)}%</Td>
										<Td width={100} bold alignCenter fontSize={18}>{FormatUtils.formatarValorTelaDecimal(item.percentual_realizado_mes3, 2)}%</Td>
									</Tr>

									<Tr>
										<Td width={500} bold fontSize={18}>Faixa</Td>
										<Td width={100} bold alignCenter fontSize={18}></Td>
										<Td width={100} bold alignCenter fontSize={18}>{item.pagamento_faixa_realizado_nome_mes1}</Td>
										<Td width={100} bold alignCenter fontSize={18}>{item.pagamento_faixa_realizado_nome_mes2}</Td>
										<Td width={100} bold alignCenter fontSize={18}>{item.pagamento_faixa_realizado_nome_mes3}</Td>
									</Tr>

									<Tr>
										<Td width={500} bold fontSize={18}>Valor</Td>
										<Td width={100} bold alignCenter fontSize={18}>R$ {FormatUtils.formatarValorTelaDecimal(item.pagamento_valor_faixa3, 2)}</Td>
										<Td width={100} bold alignCenter fontSize={18}>R$ {FormatUtils.formatarValorTelaDecimal(item.pagamento_faixa_realizado_valor_mes1, 2)}</Td>
										<Td width={100} bold alignCenter fontSize={18}>R$ {FormatUtils.formatarValorTelaDecimal(item.pagamento_faixa_realizado_valor_mes2, 2)}</Td>
										<Td width={100} bold alignCenter fontSize={18}>R$ {FormatUtils.formatarValorTelaDecimal(item.pagamento_faixa_realizado_valor_mes3, 2)}</Td>
									</Tr>

									<Tr>
										<Td width={500} bold fontSize={18}>Total</Td>
										<Td width={100} bold alignCenter fontSize={18}>R$ {FormatUtils.formatarValorTelaDecimal(item.pagamento_valor_faixa3 * 3, 2)}</Td>
										<Td width={100} colspan={3} bold alignCenter fontSize={18}>R$ {
											FormatUtils.formatarValorTelaDecimal(
												parseFloat(item.pagamento_faixa_realizado_valor_mes1 || 0)
												+ parseFloat(item.pagamento_faixa_realizado_valor_mes2 || 0)
												+ parseFloat(item.pagamento_faixa_realizado_valor_mes3 || 0), 2)
										}</Td>
									</Tr>
								</TBody>
							</Table>
						);
					})}
				</ContentCardBody>
			</ContentCard>
		);
	}

	setModalReprocessar(registro) {
		this.setState({
			...this.state,
			modalRegistro: registro
		});
	}

	modalReprocessar() {

		if (!this.state.modalRegistro) {
			return null;
		}

		return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Reprocessar</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setModalReprocessar(null)}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body'>		
							<Row>
								<Grid cols='12 12 12 12'>
									<label style={{ fontSize: 18 }}>Indicador I — Eficiência Operacional (Tempo de Carga/Descarga)</label>
								</Grid>
							</Row>
							<br />
							<Row>
								<LabelAndCheckbox
									label='Houve Incidente (Mês 1)'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.operacional_incidente_mes1}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											operacional_incidente_mes1: !this.state.modalRegistro.operacional_incidente_mes1
										});
									}} />

								<LabelAndCheckbox
									label='Houve Incidente (Mês 2)'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.operacional_incidente_mes2}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											operacional_incidente_mes2: !this.state.modalRegistro.operacional_incidente_mes2
										});
									}} />								
                				
								<LabelAndCheckbox
									label='Houve Incidente (Mês 3)'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.operacional_incidente_mes3}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											operacional_incidente_mes3: !this.state.modalRegistro.operacional_incidente_mes3
										});
									}} />
							</Row>

							<br />
                
							<Row>
								<Grid cols='12 12 12 12'>
									<label style={{ fontSize: 18 }}>Indicador III — Cumprimento de Leis e Normas Internas</label>
								</Grid>
							</Row>
							<br />
							<Row>
								<Grid cols='12 12 12 12'>
									<label>Mês 1</label>
								</Grid>
							</Row>
							<Row>
								<LabelAndCheckbox
									label='Não registrou checklist de gabine'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.qualidade_perdeu_checklist_gabine_mes1}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											qualidade_perdeu_checklist_gabine_mes1: !this.state.modalRegistro.qualidade_perdeu_checklist_gabine_mes1
										});
									}} />

								<LabelAndCheckbox
									label='Autuação por inobservância de norma ou lei'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.qualidade_perdeu_lei_norma_mes1}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											qualidade_perdeu_lei_norma_mes1: !this.state.modalRegistro.qualidade_perdeu_lei_norma_mes1
										});
									}} />								
                				
								<LabelAndCheckbox
									label='Dano caudado por conduta imprudente'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.qualidade_perdeu_imprudencia_mes1}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											qualidade_perdeu_imprudencia_mes1: !this.state.modalRegistro.qualidade_perdeu_imprudencia_mes1
										});
									}} />
							</Row>
							<Row>
								<Grid cols='12 12 12 12'>
									<label>Mês 2</label>
								</Grid>
							</Row>
							<Row>
								<LabelAndCheckbox
									label='Não registrou checklist de gabine (Mês 2)'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.qualidade_perdeu_checklist_gabine_mes2}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											qualidade_perdeu_checklist_gabine_mes2: !this.state.modalRegistro.qualidade_perdeu_checklist_gabine_mes2
										});
									}} />

								<LabelAndCheckbox
									label='Autuação por inobservância de norma ou lei'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.qualidade_perdeu_lei_norma_mes2}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											qualidade_perdeu_lei_norma_mes2: !this.state.modalRegistro.qualidade_perdeu_lei_norma_mes2
										});
									}} />								
                				
								<LabelAndCheckbox
									label='Dano caudado por conduta imprudente'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.qualidade_perdeu_imprudencia_mes2}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											qualidade_perdeu_imprudencia_mes2: !this.state.modalRegistro.qualidade_perdeu_imprudencia_mes2
										});
									}} />
							</Row>
							<Row>
								<Grid cols='12 12 12 12'>
									<label>Mês 3</label>
								</Grid>
							</Row>
							<Row>
								<LabelAndCheckbox
									label='Não registrou checklist de gabine'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.qualidade_perdeu_checklist_gabine_mes3}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											qualidade_perdeu_checklist_gabine_mes3: !this.state.modalRegistro.qualidade_perdeu_checklist_gabine_mes3
										});
									}} />

								<LabelAndCheckbox
									label='Autuação por inobservância de norma ou lei'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.qualidade_perdeu_lei_norma_mes3}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											qualidade_perdeu_lei_norma_mes3: !this.state.modalRegistro.qualidade_perdeu_lei_norma_mes3
										});
									}} />								
                				
								<LabelAndCheckbox
									label='Dano caudado por conduta imprudente'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.qualidade_perdeu_imprudencia_mes3}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											qualidade_perdeu_imprudencia_mes3: !this.state.modalRegistro.qualidade_perdeu_imprudencia_mes3
										});
									}} />
							</Row>
							
							<Row alignCenter>
								<Grid cols='6 6 4 3'>									
									<Button
										text='Confirmar'
										type={'success'}
										icon={'fa fa-check'}
										event={() => {
											this.props.processarApuracao({
												...this.state.modalRegistro
											}, () => this.setModalReprocessar(null));
										}} />
								</Grid>
							</Row>
						</div>
					</div>
				</div>
			</div>
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	modoTela: state.metaBaseOperadorTrimestre.modoTela,
	filtro: state.metaBaseOperadorTrimestre.filtro,
	lista: state.metaBaseOperadorTrimestre.listaMetaApuracao,
	listaApuracao: state.metaBaseOperadorTrimestre.listaApuracao
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, processarApuracao,
	getListaMetaApuracao, importarCustos,
	imprimir
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(MetaBaseOperadorTrimestreApuracao);
